import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form, Button, Row, Col, Nav, Spinner } from "react-bootstrap";
import "../styles/form.css";
import { useNavigate, NavLink } from "react-router-dom";
import * as Yup from "yup";
import { Formik } from "formik";

const Login = () => {
	const navigate = useNavigate();
	const [isLoaded, setIsLoaded] = useState(false);

	const initialState = {
		username: "",
		password: "",
	};

	const schema = Yup.object().shape({
		username: Yup.string().required(),
		password: Yup.string().required(),
	});

	const users = JSON.parse(localStorage.getItem("users"));

	const creds = [];

	useEffect(() => {
		if (JSON.parse(localStorage.getItem("users")) === null) {
			navigate("/signup");
		}
		setTimeout(() => {
			setIsLoaded(true);
		}, 1000);
	}, []);

	if (JSON.parse(localStorage.getItem("users")) !== null) {
		for (let user of users) {
			creds.push(`${user.username}-${user.password}`);
			console.log(creds);
		}
	}

	return (
		<>
			<div className="container">
				<div className="form-container">
					{isLoaded ? (
						<Row>
							<Col
								lg={4}
								md={12}
								style={{
									fontSize: 70,
									fontWeight: 600,
									margin: "auto",
									textAlign: "center",
								}}
							>
								Log In
							</Col>
							<Col lg={8} md={12}>
								<Formik
									validationSchema={schema}
									onSubmit={(values) => {
										if (
											creds.includes(`${values.username}-${values.password}`)
										) {
											navigate("/home", {
												state: { username: values.username },
											});
										} else {
											alert("Username or password are incorrect.");
										}
									}}
									initialValues={initialState}
									validateOnMount={true}
								>
									{({
										handleSubmit,
										handleChange,
										isValid,
										values,
										errors,
									}) => (
										<>
											<Form noValidate onSubmit={handleSubmit}>
												<fieldset>
													<legend>Login credentials</legend>
													<Row className="ps-3 pe-3">
														<Col md>
															<Form.Group className="mb-3">
																<Form.Label>Username</Form.Label>
																<Form.Control
																	type="text"
																	name="username"
																	value={values.username}
																	onChange={handleChange}
																	isInvalid={!!errors.username}
																/>
																<Form.Control.Feedback type="invalid">
																	{errors.username}
																</Form.Control.Feedback>
															</Form.Group>
														</Col>
														<Col md>
															<Form.Group className="mb-3">
																<Form.Label>Password</Form.Label>
																<Form.Control
																	type="password"
																	name="password"
																	value={values.password}
																	onChange={handleChange}
																	isInvalid={!!errors.password}
																/>
																<Form.Control.Feedback type="invalid">
																	{errors.password}
																</Form.Control.Feedback>
															</Form.Group>
														</Col>
													</Row>
												</fieldset>

												<Row>
													<Col className="d-flex justify-content-center pb-2">
														<Button
															variant="primary"
															type="submit"
															disabled={!isValid}
															className="mt-3 mb-3"
														>
															Submit
														</Button>
													</Col>
												</Row>
												<Row>
													<Col className="d-flex justify-content-center pb-2">
														<Nav activeKey="/home" className="center">
															<Nav.Item>
																<NavLink to="/signup">
																	Click here to Sign Up
																</NavLink>
															</Nav.Item>
														</Nav>
													</Col>
												</Row>
											</Form>
										</>
									)}
								</Formik>
							</Col>
						</Row>
					) : (
						<Spinner animation="border" />
					)}
				</div>
			</div>
		</>
	);
};

export default Login;
